import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function HLHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1401">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/uvXurBtLgbSzk1UhUbs2Ey/HALO-laser-be.jpg)'
    }} data-id="element-1402" />
      <div className="absolute inset-0 bg-black/60" data-id="element-1403" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1404">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-1405">
          <div className="mb-6" data-id="element-1406">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1407">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1408">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1409">
            Be CONFIDENT
          </span>

          <h1 className="text-[28px] sm:text-5xl lg:text-[52px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1410">
            OUR HALO SKIN RESURFACING LASER
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-1411">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-1412">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1413">
              For individuals seeking smoother, firmer and more rejuvenated skin
              without the need for surgery, today's laser technology is an ideal
              solution. As Dr. Fiona says,{' '}
              <em data-id="element-1414">
                "It's called HALO for a reason! If you give me a few days of
                downtime, I'll knock off years of aging!"
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1415">
              At Be CLINICAL we're proud and excited to offer Halo Skin
              Resurfacing Laser, a comprehensive approach to skin rejuvenation,
              addressing both superficial and deeper skin concerns
              simultaneously. It uses a unique hybrid technology which is
              unmatched, giving you a deeper level of collagen and elastin
              stimulation while removing dead skin cells to improve fine lines
              and wrinkles.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1416">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}